import type { InvoiceTemplate } from '~/api/invoiceTemplates/types';

import { Separator } from '~/components';

import { mobileActionsStyle, mobileCellStyle, mobileFooterStyle, mobileHeaderStyle, mobileSeparatorStyle } from './invoiceTemplateCell.css';
import { InvoiceTemplateClientCell } from './InvoiceTemplateClientCell';
import { InvoiceTemplateNextInvoiceCell } from './InvoiceTemplateNextInvoiceCell';
import { InvoiceTemplateOptionsCell } from './InvoiceTemplateOptionsCell';
import { InvoiceTemplateTitleCell } from './InvoiceTemplateTitleCell';
import { InvoiceTemplateTotalCell } from './InvoiceTemplateTotalCell';
import { InvoiceTemplateTypeCell } from './InvoiceTemplateTypeCell';

type Props = {
  invoiceTemplate: InvoiceTemplate;
};

export const InvoiceTemplateMobileCell = ({ invoiceTemplate }: Props) => {
  return (
    <div className={mobileCellStyle}>
      <div className={mobileHeaderStyle}>
        <div>
          <InvoiceTemplateTitleCell invoiceTemplate={invoiceTemplate} />

          <InvoiceTemplateClientCell invoiceTemplate={invoiceTemplate} />
        </div>

        <div className={mobileActionsStyle}>
          <InvoiceTemplateTypeCell invoiceTemplate={invoiceTemplate} />

          <InvoiceTemplateOptionsCell invoiceTemplate={invoiceTemplate} />
        </div>
      </div>

      <Separator className={mobileSeparatorStyle} />

      <div className={mobileFooterStyle}>
        <InvoiceTemplateNextInvoiceCell invoiceTemplate={invoiceTemplate} />

        <InvoiceTemplateTotalCell invoiceTemplate={invoiceTemplate} />
      </div>
    </div>
  );
};
